module.exports = __webpack_public_path__ + "static/media/project-development.75030912.jpg";